import { RootState } from 'src/redux/root'
import { isLoading as isAnalysisLoading } from 'src/redux/slices/analysis/selectors'
import { getProject, projectApi } from 'src/redux/slices/project/endpoints'
import { isLoading as isUmibuilderLoading } from 'src/redux/slices/umibuilder/selectors'
import { isLoading as isUpgradesLoading } from 'src/redux/slices/upgrades/selectors'
import { getEntries } from 'src/redux/utils'

import { upgradesApi } from '../upgrades/endpoints'
import { SurveyConfig } from './consts'
import { SurveyProgress } from './types'

export const selectActiveProjectId = (state: RootState) => state.project.id

export const hasActiveProject = (state: RootState) => state.project.id != null

// TODO: use consts for mutation fixed cache keys
export const gisIsUploading = (state: RootState) =>
  projectApi.endpoints.uploadGISFile.select('uploadGISFile')(state).isLoading
export const isLoadingProject = (state: RootState) =>
  projectApi.endpoints.getProject.select('')(state).isLoading
export const isLoadingScenarios = (state: RootState) =>
  projectApi.endpoints.getScenarios.select('')(state).isLoading
export const isLoadingTemplateLibMetas = (state: RootState) =>
  projectApi.endpoints.getOrgTemplateLibraries.select('')(state).isLoading
export const isCreatingScenario = (state: RootState) =>
  projectApi.endpoints.createScenario.select('createScenario')(state).isLoading
export const isDeletingScenario = (state: RootState) =>
  projectApi.endpoints.deleteScenario.select('deleteScenario')(state).isLoading
export const isLoadingUpgradesPage = (state: RootState) =>
  upgradesApi.endpoints.uploadBaseUpgradingFile.select('loadUpgradeScenario')(state).isLoading
export const isUploadingTemplateLib = (state: RootState) =>
  projectApi.endpoints.uploadOrgTemplateLibrary.select('uploadOrgTemplateLibrary')(state).isLoading
export const isDownloadingTemplateLib = (state: RootState) =>
  projectApi.endpoints.downloadOrgTemplateLibrary.select('')(state).isLoading
export const isDeletingTemplateLib = (state: RootState) =>
  projectApi.endpoints.deleteOrgTemplateLibrary.select('deleteOrgTemplateLibrary')(state).isLoading
export const isUploadingResults = (state: RootState) =>
  projectApi.endpoints.uploadUmiResultsFile.select('uploadResultsUmiFile')(state).isLoading

// TODO: Typescript defs for other isloading from other slices
export const isLoading = (state: RootState): boolean => {
  return (
    gisIsUploading(state) ||
    isLoadingProject(state) ||
    isLoadingScenarios(state) ||
    isCreatingScenario(state) ||
    isUploadingResults(state) ||
    isLoadingUpgradesPage(state) ||
    isDeletingScenario(state) ||
    isUmibuilderLoading(state) ||
    isAnalysisLoading(state) ||
    isUpgradesLoading(state) ||
    isUploadingTemplateLib(state) ||
    isDownloadingTemplateLib(state) ||
    isDeletingTemplateLib(state) ||
    isLoadingTemplateLibMetas(state)
  )
}

export const makeSelectScenarioAndProjectByScenarioId = (id: number) => (state: RootState) => {
  const scenarioQuery = projectApi.endpoints.getScenarios.select('')(state)
  const scenario = scenarioQuery?.data?.find(({ id: scenarioId }) => id === scenarioId)

  const projectQuery = projectApi.endpoints.getProject.select('')(state)
  const project = projectQuery?.data
  return { scenario, project }
}

export const selectSurveyProgress = (state: RootState): SurveyProgress => {
  const progress = {
    location: {
      completed: 0,
      complete: false,
    },
    targets: {
      completed: 0,
      complete: false,
    },
    utilityTargets: {
      completed: 0,
      complete: false,
    },
    renewableSources: {
      completed: 0,
      complete: false,
    },
    stockMakeup: {
      completed: 0,
      complete: false,
    },
    fuelSettings: {
      completed: 0,
      complete: false,
    },
    fuelBalance: {
      completed: 0,
      complete: false,
    },
  }
  const { data: project } = getProject.select('')(state)
  if (!project) return progress

  getEntries(SurveyConfig).forEach(([group, groupConfig]) => {
    const fields = Object.keys(groupConfig.fields)
    const groupData = getEntries(project).filter(([key, data]) => fields.includes(key))
    const count = groupData.reduce(
      (a, [_, val]) =>
        a + (val !== undefined && val !== null && val !== false && val !== '' ? 1 : 0),
      0,
    )
    progress[group].completed = count
    progress[group].complete = count === groupConfig.total
  })

  return progress
}

export const selectDrawerOpen = (state: RootState) => {
  return state.project.drawerOpen
}
